import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';

//Create Unit dependencies

import ListCompanies from './ListCompanies';
import {
  ROLE_SUPER
} from '../common/redux/constantes';

//Redirect to login
import { Redirect } from 'react-router-dom';


export class DefaultPage extends Component {

  state = {
  }


  static propTypes = 
  {
    unit: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };




  render() {
    return (
      <div >
        {Number(localStorage.getItem("role"))!==ROLE_SUPER? 
          (
            <Redirect
              push
              to={
                '/'
              }
            />
          ):
          (
            <MySideBar>
              <ListCompanies ref={instance => { this.list = instance; }}/>
            </MySideBar>
          )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    company: state.company,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/company/DefaultPage.js